import './assets/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { vuetify } from './design-system';
import vuetifyInstance from './design-system/plugins/vuetify/vuetify';
import i18n, { getInitialLocale, setI18nLanguage } from '@plugins/i18n';
import router from '@plugins/router';
import { createAclPlugin } from '@plugins/acl';
import * as Sentry from '@sentry/vue';
import '@styles/main.scss';
import '@styles/vendor/driver-tour.scss';
import 'driver.js/dist/driver.css';
import { getSentryDsn, getSentryTraceSampleRate } from '@/envProvider';

const app = createApp(App);

const sentryDsn = getSentryDsn();
if (sentryDsn) {
    Sentry.init({
        app,
        dsn: sentryDsn,
        sendDefaultPii: true,
        sampleRate: getSentryTraceSampleRate(),
    });
}

app.use(createPinia());
app.use(vuetify);
app.use(i18n);
app.use(router);
app.use(createAclPlugin());

try {
    await setI18nLanguage(getInitialLocale());
} catch (error) {
    console.warn('Failed to load initial locale, using fallback:', error);
    vuetifyInstance.locale.current.value = 'cs';
}

app.mount('#app');
